export default {
  booking_confirmation_title: 'Bookinginformation',
  booking_confirmation_body: 'Tak for din booking. Du kan se bekræftelsesdetaljer forneden.',
  location: 'Sted',
  pickup_location: 'Afhentningssted',
  dropoff_location: 'Leveringssted',
  vehicle: 'Køretøj',
  pickup_and_dropoff: 'Afhentning og levering (lokal tid)',
  distance_allowance: 'Afstandsgrænse',
  view_voucher: 'Se kupon',
  view_more_bookings: 'Se flere bookinger',
  identity_verification_body: 'Du skal bekræfte din identitet for at kunne hente bilen.',
  identity_verification_title: 'Bekræft identitet',
  search_again: 'Søg igen',
  aircon: 'aircondition',
  not_available: 'Drive &amp; Go er pt. kun tilgængelig for folk med ID og kørekort fra {profiles}, men vi arbejder hele tiden på at dække flere lande.',
  check_if_included: 'Se, om dit land er inkluderet.',
  included_in_booking: 'Inkluderet i denne booking',
  cdw_with_excess: 'CDW med selvrisiko',
  theft_protection: 'Tyveribeskyttelse med selvrisiko',
  risk_reduction: 'Risikoreduktion',
  free_extras: 'Du har ret til to gratis ekstra <br /> med denne booking.',
  total_cost: 'Samlet pris for udlejning',
  continue: 'Fortsæt',
  luggage_large_short_label: 'L',
  luggage_medium_short_label: 'M',
  luggage_small_short_label: 'S',
  luggage_large_long_label: 'large (stor)',
  luggage_medium_long_label: 'medium',
  luggage_small_long_label: 'small (lille)',
  fuel_unspecified_label: 'uspecificeret',
  transmission_manual_label: 'Manuelt',
  transmission_automatic_label: 'Automatisk',
  make_a_booking: 'Foretag en booking',
  pickup_date: 'Afhentningsdato',
  dropoff_date: 'Leveringsdato',
  driver_age: 'Chauffør mellem 30-65',
  enter_driver_age: 'Indtast chaufførens alder',
  promo_code: 'Promokode',
  search: 'Søg',
  dropoff_date_cannot_be_before_pickup_date: 'Leveringsdato kan ikke være før afhentningsdato',
  pickup_date_cannot_be_in_the_past: 'Afhentningsdato kan ikke være i fortiden',
  pickup_time_cannot_be_in_the_past: 'Afhentningstidspunkt kan ikke være i fortiden',
  dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Leveringstidspunkt skal være senere end afhentningstidspunkt, hvis samme dag',
  vehicle_filters: 'Bilfiltre',
  reset: 'Nulstil',
  transmission: 'Gear',
  all: 'Alle',
  manual: 'Manuelt',
  auto: 'Automatisk',
  passengers: 'Passagerer',
  vehicle_type: 'Biltype',
  filter: 'Filtrér',
  vehicle_search: 'Bilsøgning',
  edit: 'Redigér',
  no_results: 'Ingen resultater på de valgte kriterier',
  small_cars: 'Små biler',
  medium_cars: 'Mellemstore biler',
  large_cars: 'Store biler',
  estate_cars: 'Stationcars',
  suvs: 'SUV\'er',
  mpvs: 'MPV\'er',
  vans: 'Varevogne',
  camper_vans: 'Campingbiler',
  premium: 'Premium',
  unspecified: 'uspecificeret',
  large: 'large (stor)',
  medium: 'medium',
  small: 'small (lille)',
  automatic: 'automatisk',
  you_have_been_refunded: 'Du er blevet refunderet.',
  please_customer_service: 'For at foretage en booking skal du kontakte vores kundeservice.',
  contact_customer_service: 'Kontakt kundeservice',
  booking_failed: 'Din booking kunne ikke behandles i tide',
  summary: 'Overblik',
  reforestation_and_protection: 'Hjælp arbejdet med at beskytte regnskoven over hele Costa Rica',
  cost_of_rental: 'Pris for udlejning',
  to_pay_now: 'Til betaling nu',
  pay_on_arrival: 'Til betaling ved ankomst',
  greenheart_donation: 'Green Heart-donation',
  tc_agreement: 'Jeg har læst og forstået {0}.',
  tc: 'Vilkår og Betingelser',
  receive_offers: 'Jeg vil gerne modtage gode tilbud pr. e-mail.',
  donate: 'Ja, jeg vil gerne donere {amount}',
  pay_now: 'Betal {amount} nu',
  driver_details: 'Chaufførens oplysninger',
  complete_driver_details: 'Udfyld venligst oplysninger om chaufføren.',
  are_you_the_driver: 'Er du chaufføren?',
  have_an_account: 'Har du allerede en konto?',
  login: 'Log ind',
  or: 'eller',
  first_name: 'Chaufførens fornavn',
  last_name: 'Chaufførens efternavn',
  email: 'E-mailadresse',
  phone_number: 'Mobilnummer',
  unable_to_save_driver_information: 'Kunne ikke gemme oplysninger om chauffør Forsøg igen.',
  pay_on_arrival: 'Betal ved ankomst',
  pay_online_now: 'Betal online nu',
  day: 'Dag',
  choose_location: 'Vælg et sted',
  pickup_location: 'Afhentningssted',
  dropoff_location: 'Leveringssted',
  location_not_found: 'Beklager, vi kunne ikke finde det ønskede sted.',
  add: 'Tilføj',
  remove: 'Fjern',
  free_extra: 'Gratis ekstra',
  free: 'GRATIS!',
  fast_track_notice: 'Begrænsninger på dokumentoprindelse gælder for denne tjeneste. Er kun tilgængelig, hvis du har dokumenter fra',
  complete_booking: 'Gennemfør booking',
  choose_card: 'Vælg et kort eller tilføj et nyt.',
  add_billing_details: 'Skriv faktureringsadresse her.',
  card_number: 'Kortnummer',
  card_holder_name: 'Kortholders navn',
  card_exp: 'MM / ÅÅ',
  card_cvc: 'CVC',
  save_card: 'Gem kort?',
  amount_charged: 'Dit kort debiteres',
  payment_confirmation: 'Bekræft booking og betal',
  payment_methods: 'tilgængelige betalingsmetoder',
  use_saved_card: 'x brug gemt kort',
  use_different_card: '+ brug et andet kort',
  book_now: 'Book nu',
  minimum_age: 'Kun over {age}',
  excess_liability: 'Selvrisiko',
  security_deposit: 'Depositum',
  fuel_policy: 'Benzinpolitik',
  like_for_like: 'Identisk erstatning',
  full_to_full: 'Fuld til fuld',
  miles_per_rental: '{mileage} gratis miles pr. udlejling',
  km_per_rental: '{mileage} gratis kilometer pr. udlejling',
  unlimited: 'Ubegrænset',
  unlimited_mileage: 'Ubegrænset afstand',
  unlimited_mileage_km: 'Ubegrænset km',
  non_amendable: 'Ikke-ændringsberettiget',
  non_refundable: 'Ikke-refusionsberettiget',
  free_cancellation_until: 'Gratis annullering indtil',
  cancellation_in_line_with: 'Annullering i overensstemmelse med',
  tcs: 'T&amp;C',
  free_extras_on_collection: 'To gratis ekstra i denne samling',
  glass_and_tyres_covered: 'Glas og dæk dækkes',
  number_of_passengers: 'Antal passagerer',
  number_of_bags: 'Antal tasker',
  fuel_type: 'Benzintype',
  co2: 'CO2',
  aircon: 'Aircondition',
  refrigeration: 'Nedkølet',
  book_type: 'Book {type}',
  processing: 'Behandler',
  actual_price: 'Faktisk pris',
  tooltip: 'Prisen i ${currencyCode} er omtrentlig og baseret på valutakursen. Prisen i ${currency} er bindende.',
  deposit: 'Deponér',
  pay_online: 'Betal online nu',
  pay_online_without_extras: 'Udlejningspris',
  extras_on_arrival: 'Ekstra ved ankomst',
  insurance_on_arrival: 'Risikoreduktion – betal ved ankomst',
  insurance_online: 'Risikoreduktion – betal nu',
  extras_online: 'Ekstra – betal nu',
  green_heart_donation: 'Green Heart-donation',
  aircon_lower: 'aircondition',
  why_use_drive_and_go: 'Hvorfor bruge Drive & Go?',
  straight_to_car: 'Gå direkte til bilen',
  no_queues: 'Der er ingen køer',
  self_checkout: 'Du kan selv tjekke køretøjet ud',
  cant_lose_key: 'Nøglen bliver ikke væk',
  online_id_check: 'ID-tjek online',
  phone_as_key: 'Brug din telefon som nøgle',
  premiumplus_benefits_includes: 'Premium Plus+-fordele inkluderet',
  book_drive_go: 'Book Drive & Go',
  duration: 'Varighed',
  to_pay_on_arrival: 'Til betaling ved ankomst',
  return_date: 'Returdato',
  my_profile: null,
  additional_options: 'Andre muligheder',
  booking_details: 'Bookingoplysninger',
  price_for_x_days: 'Pris for {qty_of_days} dag | Pris for {qty_of_days} dage',
  cancelled: 'Annullér',
  upcoming: 'Kommende',
  active: 'Aktiv',
  drive_and_go: {
    drive_and_go: 'Drive And Go',
    available_countries: 'Drive &amp; Go er pt. kun tilgængelig for folk med ID og kørekort fra de følgende lande:',
    drive_and_go_today: 'Book med Drive & Go i dag!',
    drive_and_go_shortened: 'Drive & Go',
    why_use_drive_and_go: 'Hvorfor bruge Drive & Go?',
    straight_to_car: 'Gå direkte til bilen',
    no_queues: 'Der er ingen køer',
    self_checkout: 'Du kan selv tjekke køretøjet ud',
    cannot_lose_the_key: 'Nøglen bliver ikke væk',
    online_id_check: 'ID-tjek online',
    phone_as_a_key: 'Brug din telefon som nøgle',
    premium_plus_benefits_also_included: 'Premium Plus+-fordele inkluderet',
    book_drive_and_go: 'Book Drive & Go'
  },
  my_bookings: 'My bookings',
  no_bookings: 'No bookings',
  no_bookings_to_display: 'Ingen bookinger at vise',
  search_great_car_rental_deals: 'Search great car rental deals for your next trip.',
  odometer_at_collection: 'Kilometertæller ved afhentning',
  fuel_at_collection: 'Benzin ved afhentning',
  start_check_in: 'Begynd at tjekke ind',
  start_collection: 'Påbegynd afhentning',
  recent_bookings: 'Seneste bookinger',
  damage: {
    updated_damage_report_submitted: 'En opdateret skadesrapport er indsendt. Vores kundeservice kontakter dig, hvis det bliver nødvendigt.',
    add_additional_damage: 'Tilføj yderligere skade',
    you_may_report_additional_damage_up_to: 'Du kan rapportere yderligere skade op til 24 timer efter checkout',
    specify_damage: 'Specificér skade',
    please_choose_the_area_and_type_of_damage: 'Vælg skadeområde og -type',
    type_of_damage: 'Vælg skadetype',
    is_this_more_than_5_cm: 'Er skaden større end 5 cm?',
    please_take_or_select_a_photo: 'Tag eller vælg et billede',
    please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Tag et billede, hvor skaden er tydeligt vist',
    if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Hvis det er nødvendigt, kan du tilføje et andet billede ved at trykke på ikonet',
    save_image: 'Gem billede',
    save_images: 'Gem billeder',
    damage_saved_successfully: 'Skade gemt',
    add_photo: 'Tilføj billede'
  },
  checkout: {
    start_collection: 'Påbegynd afhentning',
    collect_vehicle: 'Afhent køretøj',
    we_will_let_you_know_the_details: 'Vi giver dig besked om køretøjets placering og oplysninger, så du kan finde det.',
    inspect: 'Inspicér',
    we_will_ask_for_four_photos_from_each_corner: 'Vi beder om fire billeder fra hvert hjørne af køretøjet samt af nye skader, der ikke allerede er registreret.',
    fuel_and_milage: 'Benzin og kilometer',
    you_confirm_the_readings_at_the_start_of_your_hire: 'Du bekræfter aflæsningerne af kilometertæller og benzin ved udlejningsstart.',
    sign: 'Underskriv',
    sign_the_rental_agreement: 'Underskriv lejeaftalen.',
    away_you_go: 'God tur',
    you_are_free_to_take_to_the_road: 'Du kan nu køre frit af sted!',
    collect_your_vehicle: 'Afhent dit køretøj',
    get_directions: 'Få vejvisning',
    hide_directions: 'Skjul vejvisning',
    local_time: 'lokal tid',
    tel: 'Tlf.',
    getting_to_the_location: 'Nå frem til placeringen',
    get_vehicle_details: 'Se oplysninger om køretøj',
    view_map: 'Se kort',
    unlock_vehicle_and_continue: 'Lås køretøj op og fortsæt',
    unable_to_connect_to_vehicle: 'Ingen forbindelse til køretøj',
    we_were_unable_to_connect_to_the_vehicle_please_check: 'Vi kunne ikke oprette forbindelse til køretøjet – tjek en ekstra gang, at du befinder dig ved det rigtige køretøj, og prøv igen.',
    we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Vi kunne ikke finde køretøjsbookingen. Forsøg igen lidt senere.',
    odometer_and_fuel: 'Kilometertæller og benzin',
    odometer: 'Kilometertæller',
    please_confirm_the_odometer_and_fuel_readings: 'Bekræft aflæsningerne af kilometertæller og benzin.',
    the_odometer_field_is_required: 'Kilometertællerfeltet er påkrævet,',
    and_must_be_greater_than_the_checkout_odometer: 'og tallet skal være større end ved checkout',
    confirm: 'Bekræft',
    please_take_a_photo_from_each_corner_of_the_vehicle: 'Tag et billede fra hvert hjørne af køretøjet',
    pre_existing_damage: 'Tidligere skade',
    no_pre_existing_damage: 'Ingen tidligere skade',
    new_damage: 'Ny skade',
    add_additional_damage: 'tilføj ny skade',
    no_new_damage_to_report: 'Ingen ny skade at anmelde',
    checkout_complete: 'Checkout gennemført',
    start_rental: 'Påbegynd udlejning',
    congratulations_name_it_is_time_to_take_to_the_road: 'Tillykke {customer_name}, du kan nu køre frit af sted!',
    we_are_unable_to_complete_your_vehicle_checkout: 'Vi kunne ikke gennemføre checkout af køretøjet.',
    please_do_the_following: 'Gør venligst følgende',
    remove_all_belonging_and_lock_the_vehicle: 'Fjern alle ejendele, og lås køretøjet.',
    lock_vehicle: 'Lås køretøj',
    once_you_have_contacted_customer_services: 'Når du har kontaktet kundeservice',
    vehicle_location: 'Køretøjets placering',
    collect_your: 'Afhent din',
    from: 'Fra',
    key_in_glove_box: 'din nøgle er placeret i handskerummet',
    
    keyholder: {
      not_detected: 'Nøgle ikke registreret i nøgleholderen',
      not_detected_please_try_again: 'Placer din nøgle i nøgleholderen, og prøv derefter igen.',

      not_installed: 'Nøgleholder ikke installeret',
      not_installed_please_contact_customer_service: 'Nøgleholder er ikke installeret. Kontakt kundeservice.',
    },
    keyring: {
      look_up_failed: 'Nøglering af opslag mislykkedes',
      look_up_failed_please_contact_customer_service: 'Nøglering slå op faled, så kontakt kundeservice.',
    },
    key: {
      invalid: 'Nøglen er ugyldig',
      invalid_please_contact_customer_service: 'Din nøgle er ugyldig. Kontakt kundeservice.',

      expired: 'Nøglen er udløbet',
      expired__please_contact_customer_service: 'Din nøgle er udløbet. Kontakt kundeservice.',
    }
  },
  checkin: {
    tell_us_where_you_have_parked: 'Fortæl os, hvor du har parkeret køretøjet.',
    fuel_and_milage: 'Brændstof og benzin',
    you_confirm_the_readings_at_the_end_of_your_hire: 'Du bekræfter aflæsningerne af kilometertæller og benzin ved afslutning af udlejningen.',
    inspect: 'Inspicér',
    we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Vi beder om fire billeder fra hvert hjørne af køretøjet samt af nye skader, der eventuelt skete under udlejningen.',
    lock: 'Lås',
    check_you_have_left_no_belonging_then_lock_the_vehicle: 'Tjek, at du har husket alle ejendele, før du låser køretøjet.',
    please_tell_us_where_you_have_parked_the_vehicle: 'Fortæl os, hvor du har parkeret køretøjet',
    once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Når køretøjet er låst, kan du ikke låse det op igen.',
    name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}, skal du kontrollere, at du ikke har efterladt nogen ejendele, lås køretøjet og returner om nødvendigt den fysiske nøgle til nøgleholderen.',
    lock_vehicle: 'Lås køretøj',
    complete_check_in: 'Afslut aflevering',
    inspection: 'Inspektion',
    complete_vehicle_check_in: 'Afslut aflevering af køretøjet',
    we_are_unable_to_complete_your_vehicle_check_in: 'Vi kunne ikke gennemføre aflevering af køretøjet.',
    please_contact_customer_services: 'Kontakt venligst kundeservice',
    once_you_have_contacted_customer_services: 'Når du har kontaktet kundeservice'
  },
  rental_agreement: {
    rental_agreement: 'Lejeaftalen',
    agreement_between: 'Aftale mellem',
    and: 'og',
    sign_rental_agreement: 'Underskriv lejeaftalen',
    i_have_read_and_understood_the_terms_and_conditions: 'Jeg har læst og forstået Vilkår og Betingelser og accepterer køretøjets tilstand'
  },
  full_insurance_no_deposit: 'Tam sigorta ve depozito gerekmez',
  excess: '{amount} fazla',
  deposit: '{amount} depozito',
  included_daily_distance: 'günlük {distance} {unit}',
  miles: 'mil',
  kilometers: 'kilometre',
  collection_details_title: 'Samlingsoplysninger',
  collection_details_not_found: 'Ingen samlingsoplysninger defineret for denne placering',
  free_cancellation: 'Gratis aflysning indtil',
  no_deposit: 'uden indskud',
  benefit_from: 'Drage nytte af',
  for_only_per_day: 'For kun {price} per dag',
  upgrade_mee: 'UpgradeMee'
} 


// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/da/bookings.js